import { fromJS } from 'immutable';

export const initialState = fromJS({
    billingInfo: {},
    bankAccountDetails: {},
    paymentTypesList: []
});
